@if (set_html) {
  <div [innerHTML]="set_html"></div>
}
